export const serviceData = [
    {
      category: "Nail Services",
      items: [
        { name: "Regular Full Set", price: "$30" },
        { name: "Regular Fill", price: "$25" },
        { name: "Pink & White Solar Set", price: "$50" },
        { name: "Pink & White Fill", price: "$45" },
        { name: "Pink Fill", price: "$30" },
        { name: "Full Set (White Tip)", price: "$38" },
        { name: "Full Set (Color Tip)", price: "$40" },
        { name: "Full Set (Color Powder)", price: "$45" },
        { name: "Fill Color Powder", price: "$35" },
        { name: "Full Set (Color Powder Tips)", price: "$50" },
        { name: "Nail Soak Off", price: "$10 & up" },
        { name: "Nail Soak Off w/Manicure", price: "$25 & up" },
        { name: "Nail Repair", price: "$5" },
        { name: "Nail Design", price: "$5 & up" },
        { name: "Polish Change Toes", price: "$10 & up" },
        { name: "Nail Cut Short Extra", price: "$5" },
      ]
    },
    {
      category: "Waxing Services (Appointment Only)",
      items: [
        { name: "Eye Brow", price: "$12" },
        { name: "Lips", price: "$6" },
        { name: "Chin", price: "$6 & up" },
        { name: "Full Face", price: "$30 & up" },
        { name: "Under Arms", price: "$20 & up" },
        { name: "Full Arms", price: "$35 & up" },
        { name: "Half Arms (Elbow Down)", price: "$25 & up" },
        { name: "Full Legs", price: "$60 & up" },
        { name: "Half Legs (Knee Down)", price: "$40" },
        { name: "Chest", price: "$35 & up" },
        { name: "Back", price: "$40 & up" },
        { name: "Stomach", price: "$20 & up" },
        { name: "Bikini Line", price: "$30 & up" },
        { name: "Brazilian", price: "$50 & up" },
        { name: "String (Full Face)", price: "$40 & up" },
        { name: "Eyebrow Tint", price: "$20" },
        { name: "Eyelash Tint", price: "$20" },
        { name: "Eyelash Extension Set", price: "$100" },
        { name: "Eyelash Refill", price: "$60" },
      
      ]
    },
    {
      category: "Dipping Powder",
      items: [
        { name: "Dipping on Natural Nails", price: "$42" },
        { name: "Dipping French", price: "$47" },
        { name: "Add Tip on Dipping", price: "$5" },
        { name: "Add Long Nail", price: "$5 & up" },
      ]
    },
    
    {
      category: "Gel Nail Services",
      items: [
        { name: "Gel Color w/Manicure", price: "$35" },
        { name: "Gel French w/Manicure", price: "$40" },
        { name: "Gel Color w/O Manicure", price: "$22" },
        { name: "Gel French w/O Manicure", price: "$25" }
      ]
    },
    
    {
      category: "Pedicure & Manicure",
      items: [
        { name: "Regular Manicure", price: "$18" },
        { name: "Regular Pedicure", price: "$30" },
        { name: "Pedicure & Manicure Combo", price: "$47" },
        { name: "Paradise Tropical Manicure", price: "$27" },
        { name: "Hawaiian Rose Spa Pedicure", price: "$27" },
        { name: "Cappuccino Latte Spa", price: "$43" },
        { name: "Margarita Spa Pedicure", price: "$43" },
        { name: "Fruit Smoothie Spa Pedicure", price: "$43" },
        { name: "Lavender Love Spa Pedicure", price: "$43" },
        { name: "Milk and Honey Pedicure", price: "$53" },
        { name: "Green Tea Pleasure Pedicure", price: "$53" },
        { name: "Cuccio Star Pomegranate Pedicure", price: "$53" },
        { name: "Mandarin mango Pedicure (Organic)", price: "$62" },
        { name: "Bamboo Pedicure", price: "$62" },
        { name: "Warm Earth Pedicure", price: "$62" },
        { name: "OPI Fresh Cucumber Therapy Pedicure", price: "$62" },
        { name: "OPI Paradise Tropical Pedicure", price: "$62" },
      ]
    },
  ];